import { render, staticRenderFns } from "./GaugingTubesDetail.vue?vue&type=template&id=40f353fd"
import script from "./GaugingTubesDetail.vue?vue&type=script&lang=js"
export * from "./GaugingTubesDetail.vue?vue&type=script&lang=js"
import style0 from "./GaugingTubesDetail.vue?vue&type=style&index=0&id=40f353fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports